import React from 'react';
import { Layout } from 'components/organisms';
import {
  Title, Spacer, Button, Text,
} from 'components/atoms';
import { useUserContext, actions } from 'context/UserContext';
import { logout } from 'services/requests';
import { useDispatch } from 'react-redux'
import { deleteAllDrafts } from 'redux/draftsSlice'
import { toast } from 'react-toastify';
import { Toast } from 'containers';
import { useHistory } from 'react-router-dom'

const Profile = () => {
  const history = useHistory()

  const [{ user }, dispatch] = useUserContext();
  const dispatchRedux = useDispatch()

  const handleLogout = async () => {
    try {
      dispatchRedux(deleteAllDrafts())
      await logout();
      dispatch({
        type: actions.LOGOUT_USER,
      });

      history.push('/login');
    } catch (err) {
      toast.error(
        <Toast
          type="error"
          title="Erro a fazer logout"
          description={err.message}
        />
      );
    }
  };

  const handleDeleteDrafts = () => {
    dispatchRedux(deleteAllDrafts())
    toast.success(
      <Toast
        type="success"
        title="Rascunhos apagados"
        description="Todos os rascunhos foram apagados."
      />
    );
  }

  return (
    <Layout header="Perfil" subtitle={user && user.username ? user.username : null}>
      <Title as="h3">Apagar rascunhos</Title>
      <Text modifiers="content">Todos as edições do utilizador que não foram gravadas serão eliminadas.</Text>
      <Spacer top="xs" bottom="xl2">
        <Button onClick={handleDeleteDrafts}>Apagar rascunhos</Button>
      </Spacer>

      <Title as="h3">Sair do editor</Title>
      <Text modifiers="content">Sair do editor e apagar todos os rascunhos.</Text>
      <Spacer top="xs">
        <Button modifiers={['dark']} onClick={handleLogout}>Logout</Button>
      </Spacer>
    </Layout>
  );
};

export default Profile;
